export default "__VITE_ASSET__DfHculY1__"